export default __webpack_public_path__ + "39f967c51baa3b5603627c906b1bddd9.svg";